module.exports = __webpack_public_path__ + "img/eyes_female_asian_average_mask.fb74aaf2.png";